export const enumPermisosAgrario = Object.freeze({
  agrario_cb_depositos: 16000,
  agrario_cb_retiros: 16001,
  agrario_cb_recaudo: 16002,
  agrario_cb_runt: 16004,
  pago_cartera_efectivo: 16005,
  pago_cartera_targ_credito: 16006,
});

export const enumPermisosAgrarioGestion = Object.freeze({
  agrario_cb_convenios_recaudo: 16003,
  electronic_tally: 16007,
  report_electronic_tally: 16008,
});
